import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import ProfileSection from './components/ProfileSection';
import FeaturedWorks from './components/FeaturedWorks';
import LatestNews from './components/LatestNews';
import PhotoGallery from './components/PhotoGallery';
import Newsletter from './components/Newsletter';
import FAQ from './components/FAQ';

export default function HomePage() {
  const websiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '三上悠亞 官方粉絲落地頁',
    url: 'https://luxiangba.cn/',
    description: '三上悠亞 是日本知名女演員與寫真偶像，本頁匯集三上悠亞最新作品、個人資料、出道歷程及粉絲必知資訊。',
    inLanguage: 'zh-Hant',
  };

  const organizationLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '三上悠亞官方粉絲頁',
    url: 'https://luxiangba.cn/',
    description: '三上悠亞官方粉絲落地頁，匯集最新作品、寫真、個人資料及粉絲資訊。',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <ProfileSection />
        <FeaturedWorks />
        <PhotoGallery />
        <LatestNews />
        <Newsletter />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}